import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  ShopArticleList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/ShopArticle/WebList",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  ShopArticleInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/ShopArticle/Info",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/shopArticle.js